import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import {
  OPEN_SETTINGS_EVENT,
  getConsent,
  initAnalytics,
  setConsent,
} from "../../utils/analytics";
import type { Consent } from "../../utils/analytics";

/**
 * Small bar at the bottom asking for consent to Google Analytics. Accepting
 * and declining are equally easy, and the choice can be changed later through
 * the "Cookie-Einstellungen" link in the footer.
 */
export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState<Consent | null>(null);

  useEffect(() => {
    initAnalytics();
    setCurrent(getConsent());
    setOpen(getConsent() === null);
    const reopen = () => {
      setCurrent(getConsent());
      setOpen(true);
    };
    window.addEventListener(OPEN_SETTINGS_EVENT, reopen);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, reopen);
  }, []);

  if (!open) return null;

  const choose = (value: Consent) => {
    setConsent(value);
    setCurrent(value);
    setOpen(false);
  };

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-Einstellungen"
    >
      <p className="cookie-banner__text">
        Wir nutzen Google Analytics, um zu verstehen, wie unsere Website genutzt wird. Dabei
        werden Cookies gesetzt und Daten an Google übermittelt, aber nur mit Ihrer Einwilligung.
        Ihre Wahl können Sie jederzeit im Footer ändern. Mehr dazu in der{" "}
        <Link to="/datenschutz/">Datenschutzerklärung</Link>.
        {current && (
          <>
            {" "}
            Aktuell: {current === "granted" ? "zugestimmt" : "abgelehnt"}.
          </>
        )}
      </p>
      <div className="cookie-banner__buttons">
        <button type="button" className="cookie-banner__button" onClick={() => choose("denied")}>
          Ablehnen
        </button>
        <button type="button" className="cookie-banner__button" onClick={() => choose("granted")}>
          Akzeptieren
        </button>
      </div>
    </div>
  );
}
